/**
 * Which way round a review points.
 *
 * Both sides live in one table because everything that is not the rating
 * itself — the reveal rule, moderation, reporting — has to behave
 * identically on each, and duplicated safety code drifts.
 */
export const REVIEW_SIDES = ['GUEST_ON_LISTING', 'HOST_ON_GUEST'];
/** The side opposite the one given. */
export function otherSide(side) {
    return side === 'GUEST_ON_LISTING' ? 'HOST_ON_GUEST' : 'GUEST_ON_LISTING';
}
/**
 * How a review reached us, which is also why half its columns may be null.
 *
 * Only `WEB_LINK` can carry sub-ratings, because it is the only route with
 * a form. A star typed into WhatsApp is a star and nothing else.
 */
export const REVIEW_SOURCES = ['WEB_LINK', 'WHATSAPP', 'ADMIN'];
/**
 * Moderation state, and *only* moderation state.
 *
 * Deliberately not the visibility gate. A review is public when it is
 * revealed *and* PUBLISHED, and conflating the two would let a moderation
 * write silently unpublish a revealed pair.
 */
export const REVIEW_STATUSES = ['PUBLISHED', 'HIDDEN', 'REMOVED'];
export const REVIEW_REPORT_REASONS = [
    /** Not about the trip — a complaint about Zuruflex, a political rant. */
    'OFF_TOPIC',
    'ABUSIVE',
    'SPAM',
    /** A phone number, a plate, an address, somebody's full name. */
    'PRIVATE_INFO',
    /** Says something that did not happen. The hardest to judge, and the most common. */
    'UNTRUE',
    'OTHER',
];
export const REVIEW_REPORT_STATUSES = ['OPEN', 'UPHELD', 'DISMISSED'];
/**
 * The five categories a guest scores a car on, in the order they are shown.
 *
 * `handover` is pick-up and drop-off, named for what the rest of this
 * codebase calls it — see `PartnerUserRole.STAFF`, "day-to-day: handovers".
 */
export const REVIEW_CATEGORIES = [
    'cleanliness',
    'accuracy',
    'communication',
    'handover',
    'value',
];
export const MIN_RATING = 1;
export const MAX_RATING = 5;
export function toStars(value) {
    return value / 100;
}
/** Why a side may not write one. */
export const REVIEW_BLOCKS = ['NOT_COMPLETED', 'WINDOW_CLOSED', 'ALREADY_WRITTEN'];
